// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"E5-z","colorTextValue":"F5-z","swatches":"G5-z","collapseLink":"H5-z","isCollapsed":"I5-z","dropdown":"J5-z","disabled":"K5-z"};